import { connect } from 'react-redux';
import { getBackground } from '../redux/selectors';
const mapStateToProps = (state, ownProps)=>({
        background: getBackground(state, ownProps.deviation)
    });
export default connect(mapStateToProps);

//# sourceMappingURL=StageBackground.container.js.map